import { Button, Stack, Theme, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { useLocation } from 'react-router';

import { Page } from '@/components/Layout/Page/Page';
import { OnboardingGuide } from '@/components/OnboardingGuide/OnboardingGuide';

import { useAppSelector } from '@/hooks/redux';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useTranslate } from '@/hooks/useTranslate';

import { selectUserHolderJointAdult } from '@/redux/user-data';

import { getDataTestId } from '@/utils/browser';
import { PROGRESS_STEPS } from '@/utils/progressSteps';

export default function AddAdultDetailResultPage() {
  const { t, language } = useTranslate();
  const { onBackToSignIn } = useAuthentication();
  const { state } = useLocation();
  const holderJointAdult = useAppSelector(selectUserHolderJointAdult);

  return (
    <Page
      paperProps={{
        color: (theme: Theme) => theme.palette.neutral[1000],
        position: 'right',
        size: 'big',
        children: <OnboardingGuide />,
      }}
      progressProps={PROGRESS_STEPS.thirdPartyComplianceCheckStep}
      hasLogo
    >
      <Stack
        direction="column"
        flex={1}
        justifyContent="center"
        alignItems="center"
        gap={3}
      >
        <Typography variant="h3" textAlign="center" mb={1}>
          {t('common.pageTitle.thankYou')}
        </Typography>
        <Typography variant="body2" textAlign="center" maxWidth={320}>
          <Trans
            i18nKey="page.addAdultDetailResult.content"
            language={language}
            as="div"
            values={{
              adultEmail:
                state?.adultDetail?.email ?? holderJointAdult?.email ?? '',
            }}
            components={{
              strong: <strong />,
            }}
          />
        </Typography>
      </Stack>
      <Button
        onClick={onBackToSignIn}
        {...getDataTestId('back-to-login-button')}
        variant="text"
      >
        {t('layout.page.button.backToLogin')}
      </Button>
    </Page>
  );
}
